import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import { ROLE_DASHBOARD_MAP } from '../constants/roles';
import { HomeIcon, UsersIcon, CalendarIcon, PhoneIcon } from './Icons';

const MobileMenu: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = React.useState(false);

  const isAuthenticated = !!user;

  const handleDashboardClick = () => {
    setMenuOpen(false);
    if (isAuthenticated) {
      const normalizedRole = user.role.toUpperCase().replace('-', '_');
      const dashboardPath = ROLE_DASHBOARD_MAP[normalizedRole as keyof typeof ROLE_DASHBOARD_MAP] || '/dashboard/student';
      navigate(dashboardPath);
    } else {
      navigate('/auth');
    }
  };

  const gradientButtonStyle: React.CSSProperties = {
    background: 'linear-gradient(135deg, #06b6d4 0%, #a855f7 100%)',
    border: 'none',
    borderRadius: '50px',
    padding: '14px 24px',
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: '0.95rem',
    fontFamily: "'Rajdhani', sans-serif",
    letterSpacing: '1px',
    cursor: 'pointer',
    width: '100%',
    transition: 'opacity 0.2s',
  };

  return (
    <>
      {/* Hamburger Menu Button */}
      <motion.button
        className="hamburger-btn"
        onClick={() => setMenuOpen(!menuOpen)}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        aria-label="Toggle Menu"
      >
        <motion.div
          animate={menuOpen ? 'open' : 'closed'}
          variants={{
            open: { rotate: 45, y: 8 },
            closed: { rotate: 0, y: 0 }
          }}
          className="hamburger-line"
        />
        <motion.div
          animate={menuOpen ? 'open' : 'closed'}
          variants={{
            open: { opacity: 0 },
            closed: { opacity: 1 }
          }}
          className="hamburger-line"
        />
        <motion.div
          animate={menuOpen ? 'open' : 'closed'}
          variants={{
            open: { rotate: -45, y: -8 },
            closed: { rotate: 0, y: 0 }
          }}
          className="hamburger-line"
        />
      </motion.button>

      {/* Mobile Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="mobile-menu active"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <nav className="mobile-menu-nav">
              <a href="#hero" className="mobile-menu-link" onClick={() => setMenuOpen(false)}>
                <HomeIcon size={16} /> HOME
              </a>
              <a href="#about" className="mobile-menu-link" onClick={() => setMenuOpen(false)}>
                <UsersIcon size={16} /> ABOUT
              </a>
              <a href="#events" className="mobile-menu-link" onClick={() => setMenuOpen(false)}>
                <CalendarIcon size={16} /> EVENTS
              </a>
              <a href="#contact" className="mobile-menu-link" onClick={() => setMenuOpen(false)}>
                <PhoneIcon size={16} /> CONTACT
              </a>
              <button
                className="mobile-menu-link"
                style={{
                  background: 'linear-gradient(135deg, #06b6d4 0%, #a855f7 100%)',
                  border: 'none',
                  borderRadius: '50px',
                  padding: '14px 24px',
                  color: '#ffffff',
                  fontWeight: 'bold',
                  fontSize: '0.95rem',
                  fontFamily: "'Rajdhani', sans-serif",
                  letterSpacing: '1px',
                  cursor: 'pointer',
                  width: '100%',
                  transition: 'opacity 0.2s',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
                onClick={() => {
                  navigate('/nexaprom');
                  setMenuOpen(false);
                }}
              >
                <span>✦</span> NEXAPROM
              </button>
            </nav>
            <div className="mobile-menu-auth">
              <button
                className="mobile-menu-btn"
                onClick={handleDashboardClick}
                style={gradientButtonStyle}
              >
                {isAuthenticated ? 'ENTER DASHBOARD →' : 'SIGN IN →'}
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default MobileMenu;
